import { useEffect, useState } from 'react';
import apiClient from '../../utils/apiclient';

const formatDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};

const Index = () => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const response = await apiClient.get('/Bulkwhatsapp-message/logs');
                const responseLogs = Array.isArray(response.data) ? response.data : [];
                setLogs([...responseLogs].sort((firstLog, secondLog) => {
                    const firstTime = new Date(firstLog.createdAt).getTime();
                    const secondTime = new Date(secondLog.createdAt).getTime();
                    if (firstTime !== secondTime) return secondTime - firstTime;
                    return (secondLog.id || 0) - (firstLog.id || 0);
                }));
            } catch (fetchError) {
                console.error('Error fetching bulk WhatsApp message logs:', fetchError);
                setError('Unable to load bulk WhatsApp message logs.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchLogs();
    }, []);

    return (
        <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
            <div className="flex justify-between items-center mb-2 flex-shrink-0">
                <div>
                    <h2 className="text-xl font-bold text-gray-800">WhatsApp Bulk Message Logs</h2>
                    <p className="text-sm text-gray-500">History of bulk WhatsApp messages sent</p>
                </div>
                {!isLoading && <span className="text-sm text-gray-500">{logs.length} logs</span>}
            </div>

            <div className="w-full flex-1 overflow-auto pb-4 relative">
                {isLoading && <p className="p-4 text-sm text-gray-500">Loading logs...</p>}
                {!isLoading && error && <p className="p-4 text-sm text-red-600">{error}</p>}
                {!isLoading && !error && logs.length === 0 && (
                    <p className="p-4 text-sm text-gray-500">No WhatsApp bulk message logs found.</p>
                )}
                {!isLoading && !error && logs.length > 0 && (
                    <table className="min-w-[1500px] w-full bg-white shadow-md border-collapse">
                        <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
                            <tr>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Date</th>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Template</th>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Template ID</th>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Message ID</th>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Sender Number</th>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Message</th>
                                <th className="px-3 py-3 text-xs font-semibold text-left">Recipients</th>
                                <th className="px-3 py-3 text-xs font-semibold text-right">Total Recipients</th>
                                <th className="px-3 py-3 text-xs font-semibold text-right">Price / Message</th>
                                <th className="px-3 py-3 text-xs font-semibold text-right">Total Price</th>
                                <th className="px-3 py-3 text-xs font-semibold text-right">Admin ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log) => (
                                <tr key={log.id} className="border border-gray-200 align-top hover:bg-gray-50">
                                    <td className="px-3 py-3 text-sm text-gray-700 whitespace-nowrap">{formatDate(log.createdAt)}</td>
                                    <td className="px-3 py-3 text-sm font-semibold text-gray-800">{log.templateName || '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700">{log.templateId || '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700">{log.messageId || '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700">{log.senderNumber || '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700 whitespace-pre-wrap min-w-[420px]">{log.messageText || '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700 whitespace-pre-wrap">{Array.isArray(log.numbers) ? log.numbers.join('\n') : '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700 text-right">{log.totalRecipients ?? '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700 text-right">{log.pricePerMessage ?? '-'}</td>
                                    <td className="px-3 py-3 text-sm font-semibold text-gray-800 text-right">{log.totalPrice ?? '-'}</td>
                                    <td className="px-3 py-3 text-sm text-gray-700 text-right">{log.adminId ?? '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default Index;
